import * as z from "zod/v4";

export const getParcelsForCheckoutFromOmsAutomationResultSchema = z.union([
  z.object({
    result: z.literal("converged"),
    selectedParcelIds: z.array(z.string()),
  }),
  z.object({
    result: z.literal("diverged"),
    bestEffortSelectedParcelIds: z.array(z.string()),
  }),
  z.object({
    result: z.literal("learned-preset"),
    selectedParcelIds: z.array(z.string()),
  }),
]);
export type GetParcelsForCheckoutFromOmsAutomationResult = z.infer<
  typeof getParcelsForCheckoutFromOmsAutomationResultSchema
>;
